@if (cardItems().length) {
    <ur-item-slider-or-grid-view
        class="blog-posts"
        [title]="translations()!.resultPage.blogPostTitle"
        [description]="translations()!.resultPage.blogPostDescription"
        [items]="cardItems()">
    </ur-item-slider-or-grid-view>
    <sirius-spacer size="large"></sirius-spacer>
}
